import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "../../useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export interface IErrorMessage {
  status: boolean;
  message: string;
}

export interface IClinicLocationScriptData {
  whatsapp_text: string;
  phone_number?: string;
  address?: string;
  nearby_landmarks?: string;
}

export const useClinicLocationScriptAPI = () => {
  const configuration = useConfiguration();
  const [clinicScriptDetails, setClinicScriptDetails] = useState<IClinicLocationScriptData | null>(null);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (clinicId: string): Promise<IErrorMessage> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: IErrorMessage = await axios
          .get(`${BOOKING_APIS?.CLINIC_LOCATION_WHATSAPP_SCRIPT?.baseURL}?clinic_id=${clinicId}`, {
            headers: {
              Authorization: `${accessToken}`,
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              setClinicScriptDetails(res.data.data);
              return { status: true, message: res.data?.message };
            } else {
              setClinicScriptDetails(null);
              toast.error("Clinic Location Script Fetch Failed");
              return { status: false, message: res.data?.message };
            }
          })
          .catch((e: AxiosError) => {
            setClinicScriptDetails(null);
            sendCurl(e?.config?.["curlCommand"]);
            captureError(e);
            toast.error("Clinic Location Script Fetch Failed");
            return { status: false, message: "" };
          });

        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, message: "" };
      }
    },
    [dispatch, sendCurl, captureError],
  );

  return { execute, clinicScriptDetails };
};
